import { useRef, useState } from "react";
import { Upload, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api, resolveUrl, formatApiError } from "@/lib/api";

export const UploadField = ({ label, value, onChange, accept = "image/*", pdf = false, video = false, testId }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url, data.original_filename);
      toast.success("Uploaded");
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setBusy(false); }
  };

  return (
    <div data-testid={testId}>
      <label className="admin-label">{label}</label>
      <div className="flex items-center gap-3">
        {value && video && <video src={resolveUrl(value)} muted playsInline className="h-14 w-10 object-cover bg-black rounded" />}
        {value && !pdf && !video && <img src={resolveUrl(value)} alt="" className="h-14 w-20 object-contain bg-white border border-[var(--sand)] rounded" />}
        {value && pdf && <a href={resolveUrl(value)} target="_blank" rel="noreferrer" className="text-xs text-[var(--terracotta)] underline truncate max-w-[180px]">Current PDF</a>}
        <button type="button" onClick={() => ref.current.click()} disabled={busy} data-testid={testId ? `${testId}-button` : undefined} className="inline-flex items-center gap-2 text-sm border border-[var(--sand)] bg-white rounded-md px-3 py-2 hover:border-[var(--ink)] transition-colors disabled:opacity-60">
          {busy ? <Loader2 size={14} className="animate-spin" /> : <Upload size={14} />} {value ? "Replace" : "Upload"}
        </button>
        {value && <button type="button" onClick={() => onChange("", "")} className="text-[var(--muted)] hover:text-red-600" title="Remove" data-testid={testId ? `${testId}-remove` : undefined}><X size={14} /></button>}
        <input ref={ref} type="file" accept={accept} className="hidden" onChange={(e) => upload(e.target.files[0])} data-testid={testId ? `${testId}-input` : undefined} />
      </div>
      <input className="admin-input mt-2 text-xs" placeholder="…or paste an image/PDF URL" value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={testId ? `${testId}-url` : undefined} />
    </div>
  );
};
